import { NextPage } from "next";
import Head from "next/head";
import LoadingPage from "../components/LoadingPage";
import { WithSidebar } from "../components/Sidebar";
import useData from "../src/useData";
import MainContent from "@/components/MainContent";

type ProductPortalJwtData = {
  jwt: string;
};

const ProductPortal: NextPage = () => {
  const { data, isLoading } = useData<ProductPortalJwtData>(
    "/web/product_portal_jwt"
  );
  return (
    <>
      <Head>
        <title>Oso Cloud - Feature Requests</title>
      </Head>
      <WithSidebar>
        <div>
          <MainContent>
            <div className="font-space text-3xl">Feature Requests</div>
            <div className="mt-2 mb-5 max-w-[1000px]">
              Help us make Oso Cloud better! See below for existing feature
              requests or to submit your own.
            </div>
          </MainContent>
          {isLoading || !data ? (
            <LoadingPage />
          ) : (
            <iframe
              className="w-full h-[calc(100vh-8rem)] overflow-auto"
              src={`https://portal.productboard.com/e9d3whkdijsqsagsfxanpvux?hide_header=1&token=${data.jwt}`}
              frameBorder="0"
            />
          )}
        </div>
      </WithSidebar>
    </>
  );
};

export default ProductPortal;
